<template>
    <v-select 
       :value="selected_role" 
       v-bind:items="roles"
       item-value="code" 
       item-text="description" 
       :label="label"
       :dense="isDense" 
       :clearable="isClearable"
       @change="updateData">
    </v-select>
</template>

<script>
export default {
    props: {
        selected_role: {
            type: String,
            default: ''
        },              
        label: String,
        field: {
            type: String,
            default: 'role',
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        showInactive: {
            type: Boolean,
            default: false
        },
        isDense:{
            type: Boolean,
            default: true
        }
    },
    created() {
        this.getRoles();
    },    
    data() {
        return {
            roles: [],
        }
    },    
    methods: {
        getRoles() {
            this.$axios
                .post("ares/json/ares/eign/ctrl/getCtrl.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getCtrl"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error.message);
                    } else {
                        this.roles = res.data.getCtrl;
                    }
                })
        },
        updateData(v){
            // the prop must be updated. You cannot do it directly 
            // so you must update the parent field with an emit
            this.$emit('updateData', { "field": this.field, "value": v === null ? '10' : v })
        }
    }
}

</script>